import SkeletonLoading from './SkeletonLoading';
import { RightArrowIcon } from './Icons';
import AssetLink from './AssetLink';

// Order the groups are listed in; any other type follows after these.
const TYPE_ORDER = [
    'Parts Pages',
    'Manuals',
    'Electrical Schematics',
    'Pneumatic Schematics',
    'Tutorial Videos',
    'Filler Controller Manuals',
    'Control Package',
];

const typeRank = (type) => {
    const index = TYPE_ORDER.indexOf(type);
    return index === -1 ? TYPE_ORDER.length : index;
};

// Assets as a list, with assets of the same type grouped under one heading.
// Only "View Asset" is a link, so the asset names can be selected and copied.
function AssetGroupList({ data, fetchingAssets }) {
    if (fetchingAssets || !data) return <SkeletonLoading />;
    if (data.length === 0) return <p className='w-full'> - No Files Available -</p>;

    const groups = {};
    data.forEach((item) => {
        (groups[item.type] = groups[item.type] || []).push(item);
    });
    const types = Object.keys(groups).sort((a, b) => typeRank(a) - typeRank(b));

    return (
        <div>
            {types.map((type) => (
                <div key={type} className='mb-5 last:mb-0 border border-slate-200 rounded-lg overflow-hidden'>
                    <div className='px-4 py-3 bg-slate-100 border-b border-slate-200'>
                        <h3 className='text-base md:text-lg font-semibold text-gray-700'>
                            {type} <span className='font-normal text-gray-500'>({groups[type].length})</span>
                        </h3>
                    </div>
                    <div className='divide-y divide-slate-100 bg-white'>
                        {groups[type].map((item, index) => (
                            <div
                                key={`${item._id}-${index}`}
                                className='flex flex-col md:flex-row md:items-center justify-between gap-1 md:gap-4 px-4 py-3 hover:bg-slate-50'
                            >
                                <p className='min-w-0 break-words text-sm md:text-base text-gray-700 select-text'>{item.name}</p>
                                <AssetLink
                                    asset={item}
                                    className='flex items-center shrink-0 w-fit text-sm md:text-base font-medium text-orange-500 hover:text-orange-600'
                                >
                                    <span>View Asset</span>
                                    <RightArrowIcon size='w-5 h-5 pl-1' />
                                </AssetLink>
                            </div>
                        ))}
                    </div>
                </div>
            ))}
        </div>
    );
}

export default AssetGroupList;
